import { render } from "./StorefrontBreadcrumb.vue?vue&type=template&id=b2258d56&scoped=true"
import script from "./StorefrontBreadcrumb.vue?vue&type=script&lang=js"
export * from "./StorefrontBreadcrumb.vue?vue&type=script&lang=js"

import "./StorefrontBreadcrumb.vue?vue&type=style&index=0&id=b2258d56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2258d56"]])

export default __exports__